import { AxiosRequest } from '.';
import { AxiosProgressEvent, AxiosResponse } from 'axios';
import { HttpCacheableRequest } from './http-cacheable-request';

type ProgressSubscriberArgs = { progress: number; event: AxiosProgressEvent };
export type ProgressSubscriber = (args: ProgressSubscriberArgs) => void;

/**
 * ### HttpDownloadBlobRequest Module
 *
 * Abstraction to download files
 *
 * @author <pino0071@gmail.com> Jose Aburto
 * @version v1
 */
export abstract class HttpDownloadBlobRequest<T> extends HttpCacheableRequest {
  private subscriber: Optional<ProgressSubscriber>;

  constructor() {
    super();
    this.onDownloadProgress = this.onDownloadProgress.bind(this);
    this.subscribeToProgress = this.subscribeToProgress.bind(this);
  }

  protected async dispatch(url: string): Promise<AxiosResponse<T>> {
    this.startNewAbortController();
    return await AxiosRequest.rawGet<T>(url, { signal: this.controller.signal, onDownloadProgress: this.onDownloadProgress, responseType: 'blob' }).finally(() =>
      this.setWasResolved(),
    );
  }

  public subscribeToProgress(subscriber: ProgressSubscriber): Omit<HttpDownloadBlobRequest<T>, 'onDownloadProgress'> {
    this.subscriber = subscriber;
    return this;
  }

  private onDownloadProgress(progress: AxiosProgressEvent) {
    const total = progress?.total ?? 0;
    const percentCompleted = Math.round((progress.loaded * 100) / total);
    // console.log(this?.subscriber);

    if (this?.subscriber) {
      this.subscriber({ progress: percentCompleted, event: progress });
    }
  }

  public abstract execute(url: string): Promise<Blob>;
}
